require('../../modules/es6.object.freeze');
module.exports = require('../../modules/$.core').Object.freeze;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/freeze.js
// module id = 133
// module chunks = 2